import { RealTimeAction } from '@/_core/fluxstore/types';
import { PersonaCustomField, PersonaPersonality, StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class McpUpdateStoryMapPersonaSnapshot extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'McpUpdateStoryMapPersonaSnapshot';

    public constructor(
        public personaId: string,
        public name: string,
        public description: string,
        public group: string,
        public customFields: PersonaCustomField[],
        public personalities: PersonaPersonality[]
    ) {
        super(McpUpdateStoryMapPersonaSnapshot.ACTION_TYPE);
    }
}

const middleware = async (): Promise<boolean> => {
    return true;
};

const reducer = (state: StorymapState, action: McpUpdateStoryMapPersonaSnapshot): void => {
    const persona = state.personas.find((x) => x.id === action.personaId);
    if (!persona) {
        return;
    }

    persona.name = action.name;
    persona.description = action.description ?? '';
    persona.group = action.group ?? '';
    persona.customFields = action.customFields ?? [];
    persona.personalities = action.personalities ?? [];
};

//@ts-ignore
registerMiddleware(McpUpdateStoryMapPersonaSnapshot.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(McpUpdateStoryMapPersonaSnapshot.ACTION_TYPE, reducer);
